import React, { useState } from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { CarePathTable } from '../components/care/CarePathTable';
import { CtaBand } from '../components/ui/CtaBand';
import { carePaths, carePathCategories } from '../data/carePaths';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { useBrand } from '../contexts/BrandContext';
export function Care() {
  const [category, setCategory] = useState<string>('All');
  const {
    brand
  } = useBrand();
  useDocumentMeta({
    title: `Care paths — ${brand.name}`,
    description: 'Six clinician-led care paths for perimenopause, menopause and midlife health — organised by what you are living with, not by what we sell.'
  });
  const filtered = category === 'All' ? carePaths : carePaths.filter(path => path.category === category);
  return <main className="w-full bg-cream" data-id="element-453" data-mp="1e0m6fgxck15b">
      <PageHeader eyebrow="Care paths" title="Organised by what you’re living with." intro="Every path is led by a clinician trained specifically in this transition. Every one of them will tell you plainly when hormone therapy is not the right answer for you, and what we would do instead." data-id="element-454" data-mp="1iyw541ia5jvo" />

      <section className="bg-cream" data-id="element-455" data-mp="j3ixnir7pi31">
        <div className="mx-auto max-w-shell px-6 pb-20 pt-10 md:px-8 md:pb-28 md:pt-14" data-id="element-456" data-mp="j2g4f46f33jy">
          <div className="flex flex-wrap gap-2.5" role="group" aria-label="Filter care paths" data-id="element-457" data-mp="f25niwh36sqb">
            {carePathCategories.map(item => <button key={item} type="button" onClick={() => setCategory(item)} aria-pressed={category === item} className={`rounded-brand border px-5 py-2.5 text-sm transition-colors duration-150 ease-brand ${category === item ? 'border-brick bg-brick text-cream' : 'border-ink/20 text-ink-soft hover:border-ink/45 hover:text-ink'}`} data-id="element-458" data-mp="3iimj4w43x77f">
                {item}
              </button>)}
          </div>

          <CarePathTable items={filtered} data-id="element-459" data-mp="12pedfosg4ms8" />
        </div>
      </section>

      <CtaBand data-id="element-460" data-mp="17oiokkyxkul7" />
    </main>;
}